<template>
  <div>
    <lx-expansion-panels :single-open="false" v-model="panelBaseData">
      <lx-expansion-panel :disabled="true">
        <lx-expansion-panel-header icon="mdi-account-circle"
                                   :disabled="true"
                                   :main-headline="$t('COMPONENT_PATIENT.BASE_DATA_MAIN_LINE')"
                                   :sub-headline="$t('COMPONENT_IMPORT.PATIENT_BASE_DATA_SUB_LINE')">
        </lx-expansion-panel-header>
        <lx-expansion-panel-content>
          <div class="pa-4 layout-row layout-wrap">

            <!-- Warnings if import-patient has difference to patient in tumorscout -->

            <div class="flex-gt-sm-100 mt-1 mb-6 mx-2 pa-3 flex report layout-row layout-align-start-center"
                 v-show="baseDataHasDifferences"
                 style="border:1px solid;border-radius: 9px;"
                 :class="[!compColor.isInDarkMode ? 'red' + ' lighten-5 white--text ' : '']"
                 :style="{'border-color': compColor.isInDarkMode ? '#E53935' : 'transparent'}">
              <div class="layout-column layout-align-center-center mr-3">
                <v-icon size="30" :color="'#E53935'">mdi-alert</v-icon>
              </div>

              <div class="flex-gt-sm-50 layout-column red--text darken-1">
                <span style="font-size: 18px;"><small>{{ $t('COMPONENT_IMPORT.MESSAGE_BASE_DATA_ARE_NOT_EQUAL_PART1') }}:</small></span>
                <ul>
                  <li class="ma-0 report" v-if="patient.patientDiff && patient.patientDiff.lastname">{{ $t('COMPONENT_ACCOUNT.LASTNAME') }} ({{ patient.patientDiff.lastname }})</li>
                  <li class="ma-0 report" v-if="patient.patientDiff && patient.patientDiff.firstname">{{ $t('COMPONENT_ACCOUNT.FIRSTNAME') }} ({{ patient.patientDiff.firstname }})</li>
                  <li class="ma-0 report" v-if="patient.patientDiff && patient.patientDiff.gender">{{ $t('COMPONENT_PATIENT.GENDER') }} ({{ getFieldValue(patient.patientDiff.gender, 'genderValues') }})</li>
                  <li class="ma-0 report" v-if="patient.patientDiff && patient.patientDiff.name_prefix">{{ $t('COMPONENT_PATIENT.NAME_PREFIX') }} ({{ patient.patientDiff.name_prefix }})</li>
                  <li class="ma-0 report" v-if="patient.patientDiff && patient.patientDiff.name_suffix">{{ $t('COMPONENT_PATIENT.NAME_SUFFIX') }} ({{ patient.patientDiff.name_suffix }})</li>
                  <li class="ma-0 report" v-if="patient.patientDiff && patient.patientDiff.title">{{ $t('COMPONENT_PATIENT.TITLE') }} ({{ patient.patientDiff.title }})</li>
                </ul>
              </div>

              <div class="layout-row flex layout-align-end-center">
                <lx-btn :color="'#E53935'"
                        depressed
                        classes="text-none ml-3"
                        width="auto"
                        height="35"
                        small
                        :label="$t('buttons.discard_base_data.value')"
                        @click="setBaseDataValues(patient, 'discard', 'baseData')">
                </lx-btn>
                <lx-btn :color="'#E53935'"
                        depressed
                        classes="text-none ml-1"
                        width="auto"
                        height="35"
                        small
                        :label="$t('buttons.replace_base_data.value')"
                        @click="setBaseDataValues(patient, 'replace', 'baseData')">
                </lx-btn>
              </div>
            </div>

            <!-- gender -->

            <div class="flex-gt-sm-50 flex-100 px-2">
              <validation-provider tag="div"
                                   name="patient.gender"
                                   ref="patient.gender"
                                   rules="required"
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  :label="$t('COMPONENT_PATIENT.GENDER') + ' *'"
                  v-model="patient.baseData.gender"
                  :items="genderValues"
                  outlined
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <!-- Datumsgenauigkeit birthday -->

            <div class="flex-gt-sm-50 flex-100 px-2 layout-row">
              <validation-provider tag="div"
                                   class="flex"
                                   name="patient.birthday_accuracy"
                                   ref="patient.birthday_accuracy"
                                   rules="required"
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  :label="$t('COMPONENT_PATIENT.BIRTHDAY_ACCURACY') + ' *'"
                  v-model="patient.baseData.birthday_accuracy"
                  :items="DateAccuracyTypes"
                  outlined
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <!-- title -->

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   name="patient.title"
                                   ref="patient.title"
                                   rules="name_string"
                                   v-slot="{ errors }">
                <v-combobox
                  :color="compColor.primeColor"
                  :label="$t('COMPONENT_PATIENT.TITLE')"
                  v-model="patient.baseData.title"
                  :items="titleValues"
                  outlined
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </validation-provider>
            </div>

            <!-- name praefix -->

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   name="patient.name_prefix"
                                   ref="patient.name_prefix"
                                   rules="name_string"
                                   v-slot="{ errors }">
                <v-combobox
                  :color="compColor.primeColor"
                  :label="$t('COMPONENT_PATIENT.NAME_PREFIX')"
                  v-model="patient.baseData.name_prefix"
                  :items="namePrefixValues"
                  outlined
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </validation-provider>
            </div>

            <!-- name suffix -->

            <div class="flex-gt-sm-33 flex-100 px-2">
              <validation-provider tag="div"
                                   name="patient.name_suffix"
                                   ref="patient.name_suffix"
                                   rules="name_string"
                                   v-slot="{ errors }">
                <v-combobox
                  :color="compColor.primeColor"
                  :label="$t('COMPONENT_PATIENT.NAME_SUFFIX')"
                  v-model="patient.baseData.name_suffix"
                  :items="nameSuffixValues"
                  outlined
                  :hide-details="!errors || errors.length <= 0"
                  :dense="denseFields"
                  :error-messages="errors[0]"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </validation-provider>
            </div>

            <!-- former_names -->

            <div class="flex-gt-sm-50 flex-100 px-2 layout-row">
              <div class="flex-gt-sm-100 flex-100 pr-1">
                <validation-provider tag="div"
                                     ref="patient.former_names.0"
                                     name="patient.former_names.0"
                                     rules="name_string"
                                     v-slot="{ errors }">
                  <v-text-field
                    :dark="compColor.isInDarkMode"
                    v-model="patient.baseData.former_names[0]"
                    :label="$t('COMPONENT_PATIENT.FORMER_NAMES.TITLE')"
                    :color="compColor.primeColor"
                    :error-messages="errors[0]"
                    placeholder=" "
                    outlined
                    :hide-details="!errors || errors.length <= 0"
                    :dense="denseFields"
                  ></v-text-field>
                </validation-provider>
              </div>

              <v-tooltip bottom open-delay="1000">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 ml-3"
                       :class="{'mt-1': !denseFields}"
                       style="cursor: pointer;">
                    <v-icon :color="compColor.prime" medium>info</v-icon>
                  </div>
                </template>
                <p style="max-width: 400px;" class="my-1">{{ $t('COMPONENT_PATIENT.FORMER_NAMES.TOOLTIP') }}</p>
              </v-tooltip>
            </div>

            <!-- birth_name -->

            <div class="flex-gt-sm-50 flex-100 pl-2 pr-1 layout-row">
              <div class="flex-gt-sm-100 flex-100 pr-1">
                <validation-provider tag="div"
                                     ref="patient.birth_name"
                                     name="patient.birth_name"
                                     rules="name_string"
                                     v-slot="{ errors }">
                  <v-text-field
                    :dark="compColor.isInDarkMode"
                    v-model="patient.baseData.birth_name"
                    :label="$t('COMPONENT_PATIENT.BIRTH_NAME')"
                    :color="compColor.primeColor"
                    :error-messages="errors[0]"
                    placeholder=" "
                    outlined
                    :hide-details="!errors || errors.length <= 0"
                    :dense="denseFields"
                  ></v-text-field>
                </validation-provider>
              </div>
            </div>

            <!-- patient confirm consent -->

            <div class="flex-100 px-2">
              <fake-input-frame :label="$t('COMPONENT_PATIENT.PATIENT_CONSENT_HEADER')">

                <v-radio-group v-model="patient.baseData.patient_informed_consent" row hide-details class="pt-0 pb-2 my-2 pl-3">
                  <v-radio :color="compColor.primeColor"
                           :dark="compColor.isInDarkMode"
                           class="mr-6"
                           :label="$t('COMPONENT_PATIENT.PATIENT_CONSENT_YES')"
                           :value="true"></v-radio>
                  <v-radio :color="compColor.primeColor"
                           :dark="compColor.isInDarkMode"
                           :label="$t('COMPONENT_PATIENT.PATIENT_CONSENT_NO')"
                           :value="false"></v-radio>
                </v-radio-group>
              </fake-input-frame>
            </div>

            <!-- Einwilligung nicht meldepflichtig -->

            <div class="flex-gt-sm-50 flex-100 px-2 layout-row mt-5" v-if="showNotReportableConsent">
              <label :style="{color: compColor.primeColor}" class="pt-2 mr-3 ml-1">{{ $t('COMPONENT_PATIENT.CONSENT_NOT_REPORTABLE') }} *</label>
              <validation-provider tag="div"
                                   class="layout-column"
                                   name="patient.einwilligung_nicht_meldepflichtig"
                                   ref="patient.einwilligung_nicht_meldepflichtig"
                                   rules="required"
                                   v-slot="{ errors }">
                <v-btn-toggle v-model="patient.baseData.einwilligung_nicht_meldepflichtig"
                              dense
                              class="ml-6"
                              :mandatory="!!patient.baseData.einwilligung_nicht_meldepflichtig"
                              style="margin-top:2px;
                                    background-color: transparent;"
                              :color="compColor.prime">
                  <v-btn :key="index" v-for="(kind, index) in listJN" :value="kind.value">
                    {{ kind.text }}
                  </v-btn>
                </v-btn-toggle>
                <span class="mt-1" style="color:#ff5252; font-size:12px;">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </lx-expansion-panel-content>
      </lx-expansion-panel>

      <!-- insurance data -->

      <div class="flex elevation-3 layout-column mb-3" style="border-radius: 5px;"
           :style="{'background': compColor.lxExpansion.background}">

        <div class="flex-gt-sm-100 layout-row pa-2">
          <div class="layout-align-start-center layout-column">
            <div style="border-radius:2px;width:40px;height:40px;"
                 :style="{'background': compColor.isInDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}"
                 class="mr-2 layout-column layout-align-center-center">
              <v-icon :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                      style="margin:0;">mdi-medical-bag
              </v-icon>
            </div>
          </div>

          <div class="layout-column layout-align-center-start blue-grey--text text--darken-2">
            <div class="subtitle-1 font-weight-light"
                 :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                 style="lineHeight:15px">
              <div class="layout-row layout-align-start-center">
                <span class="mr-3">{{ $t('COMPONENT_PATIENT.INSURANCE_COMPANY_DATA') }}</span>
              </div>
            </div>
            <div class="caption font-weight-light" :class="compColor.widget.subHeadline">
              {{ $t('COMPONENT_PATIENT.INSURANCE_HEADER_SUB_LINE') }}
            </div>
          </div>

          <!-- insurance_status -->

          <validation-provider tag="div" name="patient.insurance_data.insurance_status"
                               rules="required"
                               class="layout-row flex layout-align-center-center"
                               v-slot="{}">
            <span class="body-2 blue-grey--text text--lighten-2 mt-2 ml-5">{{ $t('COMPONENT_PATIENT.INSURANCE_STATE') }} *</span>
            <v-btn-toggle v-model="patient.baseData.insurance_data.insurance_status"
                          dense
                          :mandatory="!!patient.baseData.insurance_data.insurance_status"
                          class="ml-3"
                          style="margin-top:2px;"
                          :color="compColor.prime">
              <v-btn value="legal" @click="setKindOfInsuranceData('gkv')">
                {{ $t('COMPONENT_PATIENT.INSURANCE_STATE_LEGAL') }}
              </v-btn>

              <v-btn value="private" @click="setKindOfInsuranceData('pkv')">
                {{ $t('COMPONENT_PATIENT.INSURANCE_STATE_PRIVATE') }}
              </v-btn>

              <v-btn value="others" @click="setKindOfInsuranceData('sonstige')">
                {{ $t('COMPONENT_PATIENT.INSURANCE_STATE_OTHERS') }}
              </v-btn>
            </v-btn-toggle>
          </validation-provider>
        </div>

        <v-divider></v-divider>

        <div class="flex-gt-sm-100 mt-3 mb-2 mx-6 pa-3 flex report layout-row layout-align-start-center"
             v-show="insuranceDataHasDifferences"
             style="border:1px solid;border-radius: 9px;"
             :class="[!compColor.isInDarkMode ? 'red' + ' lighten-5 white--text ' : '']"
             :style="{'border-color': compColor.isInDarkMode ? '#E53935' : 'transparent'}">
          <div class="layout-column layout-align-center-center mr-3">
            <v-icon size="30" :color="'#E53935'">mdi-alert</v-icon>
          </div>

          <div class="flex-gt-sm-50 layout-column" v-bind:class="'red--text'">
            <span style="font-size: 18px;"><small>{{ $t('COMPONENT_IMPORT.MESSAGE_INSURANCE_DATA_ARE_NOT_EQUAL_PART1') }}</small></span>
            <ul>
              <li v-if="patient.patientDiff && patient.patientDiff.insurance_data && patient.patientDiff.insurance_data.insurance_status && patient.patientDiff.insurance_data.insurance_status !== patient.baseData.insurance_data.insurance_status"
                  class="ma-0 report"
                  style="font-size: 18px;">
                <small>{{ $t('COMPONENT_PATIENT.INSURANCE_STATE') }} ({{ $t('COMPONENT_PATIENT.INSURANCE_STATE_' + patient.patientDiff.insurance_data.insurance_status.toUpperCase()) }})</small>
              </li>
              <li v-if="patient.patientDiff && patient.patientDiff.insurance_data && patient.patientDiff.insurance_data.gkv && patient.patientDiff.insurance_data.insurance_status"
                  class="ma-0 report"
                  style="font-size: 18px;">
                <small>{{ $t('COMPONENT_IMPORT.MESSAGE_INSURANCE_DATA_ARE_NOT_EQUAL_GKV') }} {{ formatInsuranceDataDiff(patient.patientDiff.insurance_data.gkv, 'gkv') }}</small>
              </li>
              <li v-if="patient.patientDiff && patient.patientDiff.insurance_data && patient.patientDiff.insurance_data.pkv && patient.patientDiff.insurance_data.insurance_status"
                  class="ma-0 report"
                  style="font-size: 18px;">
                <small>{{ $t('COMPONENT_IMPORT.MESSAGE_INSURANCE_DATA_ARE_NOT_EQUAL_PKV') }} {{ formatInsuranceDataDiff(patient.patientDiff.insurance_data.pkv, 'pkv') }}</small>
              </li>
              <li v-if="patient.patientDiff && patient.patientDiff.insurance_data && patient.patientDiff.insurance_data.sonstige && patient.patientDiff.insurance_data.insurance_status"
                  class="ma-0 report"
                  style="font-size: 18px;">
                <small>{{ $t('COMPONENT_IMPORT.MESSAGE_INSURANCE_DATA_ARE_NOT_EQUAL_SONSTIGE') }} {{ formatInsuranceDataDiff(patient.patientDiff.insurance_data.sonstige, 'sonstige') }}</small>
              </li>
            </ul>
          </div>

          <div class="layout-row flex layout-align-end-center">
            <lx-btn :color="'#E53935'"
                    depressed
                    classes="text-none ml-3"
                    width="auto"
                    height="35"
                    small
                    :label="$t('buttons.discard_insurance_data.value')"
                    @click="setBaseDataValues(patient, 'discard', 'insurance_data')">
            </lx-btn>
            <lx-btn :color="'#E53935'"
                    depressed
                    classes="text-none ml-1"
                    width="auto"
                    height="35"
                    small
                    :label="$t('buttons.replace_insurance_data.value')"
                    @click="setBaseDataValues(patient, 'replace', 'insurance_data')">
            </lx-btn>
          </div>
        </div>

        <div class="px-4 pt-4 pb-2 layout-row layout-wrap">
          <ValidationObserver tag="div" class="flex" ref="InsuranceData">
            <insurance-data path="patient.insurance_data"
                            class="layout-row layout-wrap flex-gt-sm-100 flex-100"
                            v-model="patient.baseData.insurance_data"
            ></insurance-data>
          </ValidationObserver>
        </div>
      </div>

      <lx-expansion-panel :disabled="true">
        <lx-expansion-panel-header icon="mdi-home-variant"
                                   :disabled="true"
                                   :main-headline="$t('COMPONENT_PATIENT.ADDRESS')"
                                   :sub-headline="$t('COMPONENT_ADDRESS_DETAILS.HEADER_SUB_LINE')">
        </lx-expansion-panel-header>
        <lx-expansion-panel-content>

          <!-- warnings if address data have differences or are invalid -->

          <div class="flex-gt-sm-100 mt-3 mx-6 pa-3 report layout-row layout-align-start-center"
               v-if="patient && patient.patientDiff && patient.patientDiff.IsNewAddress"
               style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? 'red' + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? '#E53935' : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="'#E53935'">mdi-alert</v-icon>
            </div>

            <div class="layout-column" v-bind:class="'red--text'">
              <span class="flex-gt-sm-50" style="font-size: 18px;" :class="'red--text darken-1'"><small>{{ $t('COMPONENT_IMPORT.MESSAGE_ADDRESS_IS_NOT_EQUAL') }}</small></span>
              <span class="flex-gt-sm-50 mb-2" style="font-size: 18px;"><small>{{ $t('COMPONENT_IMPORT.MESSAGE_ADDRESS_IS_NOT_EQUAL2') }}</small></span>

              <div class="layout-row" v-if="patient.patientDiff.existingAddress">
               <span style="font-size: 18px;">
                  <small>{{ $t('COMPONENT_IMPORT.MESSAGE_ADDRESS_EXISTING_ADDRESS') }}</small>
               </span>
                <ul>
                  <li v-if="patient.patientDiff.existingAddress.street"
                      style="font-size: 18px;">
                    <small>{{ $t('COMPONENT_ADDRESS_DETAILS.STREET') }}: {{ patient.patientDiff.existingAddress.street }}</small>
                  </li>
                  <li v-if="patient.patientDiff.existingAddress.number"
                      style="font-size: 18px;">
                    <small>{{ $t('COMPONENT_ADDRESS_DETAILS.NUMBER') }}: {{ patient.patientDiff.existingAddress.number }}</small>
                  </li>
                  <li v-if="patient.patientDiff.existingAddress.zip"
                      style="font-size: 18px;">
                    <small>{{ $t('COMPONENT_ADDRESS_DETAILS.ZIP') }}: {{ patient.patientDiff.existingAddress.zip }}</small>
                  </li>
                  <li v-if="patient.patientDiff.existingAddress.city"
                      style="font-size: 18px;">
                    <small>{{ $t('COMPONENT_ADDRESS_DETAILS.CITY') }}: {{ patient.patientDiff.existingAddress.city }}</small>
                  </li>
                </ul>
              </div>
            </div>

            <div class="layout-row flex layout-align-end-center">
              <lx-btn :color="'#E53935'"
                      depressed
                      :label="$t('buttons.discard_address.value')"
                      width="auto"
                      height="35"
                      small
                      classes="text-none ml-3"
                      @click="setAddressValue(patient, 'discard')">
              </lx-btn>
              <lx-btn :color="'#E53935'"
                      depressed
                      :label="$t('buttons.replace_address.value')"
                      width="auto"
                      height="35"
                      small
                      classes="text-none ml-1"
                      @click="setAddressValue(patient, 'replace')">
              </lx-btn>
            </div>
          </div>

          <!-- address -->

          <div class="flex pa-2 pt-3">
              <div class="layout-row flex px-2 layout-wrap">

                <!-- address street -->

                <div class="flex-gt-sm-50 flex-100 pa-2 pb-0">
                  <validation-provider tag="div"
                                       name="patient.address.street"
                                       rules="required|min:2|address_string"
                                       v-slot="{ errors }">
                    <v-text-field
                      :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      :dense="denseFields"
                      :counter="200"
                      outlined
                      :hide-details="!errors || errors.length <= 0"
                      :error-messages="errors[0]"
                      :label="$t('COMPONENT_ADDRESS_DETAILS.STREET') + ' *'"
                      v-model="patient.baseData.address.street"
                    ></v-text-field>
                  </validation-provider>
                </div>

                <!-- address number -->

                <div class="flex-gt-sm-50 flex-100 pa-2 pb-0">
                  <validation-provider tag="div"
                                       name="patient.address.number"
                                       rules="address_string"
                                       v-slot="{ errors }">
                    <v-text-field
                      :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      :dense="denseFields"
                      outlined
                      :hide-details="!errors || errors.length <= 0"
                      :error-messages="errors[0]"
                      :label="$t('COMPONENT_ADDRESS_DETAILS.NUMBER')"
                      v-model="patient.baseData.address.number"
                    ></v-text-field>
                  </validation-provider>
                </div>

                <!-- address zip -->

                <div class="flex-gt-sm-50 flex-100 pa-2 pb-0">
                  <validation-provider tag="div"
                                       name="patient.address.zip"
                                       rules="required|min:2|address_string|zip_string"
                                       v-slot="{ errors }">
                    <v-text-field
                      :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      :dense="denseFields"
                      outlined
                      :hide-details="!errors || errors.length <= 0"
                      required
                      :error-messages="errors[0]"
                      :label="$t('COMPONENT_ADDRESS_DETAILS.ZIP') + ' *'"
                      v-model="patient.baseData.address.zip"
                    ></v-text-field>
                  </validation-provider>
                </div>

                <!-- address city -->

                <div class="flex-gt-sm-50 flex-100 pa-2 pb-0">
                  <validation-provider tag="div"
                                       name="patient.address.city"
                                       rules="required|min:2|address_string"
                                       v-slot="{ errors }">
                    <v-text-field
                      :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      :dense="denseFields"
                      outlined
                      :hide-details="!errors || errors.length <= 0"
                      required
                      :error-messages="errors[0]"
                      :label="$t('COMPONENT_ADDRESS_DETAILS.CITY') + ' *'"
                      v-model="patient.baseData.address.city"
                    ></v-text-field>
                  </validation-provider>
                </div>

                <!-- address land -->

                <div class="flex-gt-sm-50 flex-100 px-2">
                  <validation-provider tag="div"
                                       name="patient.address.land"
                                       rules=""
                                       v-slot="{ errors }">
                    <v-select
                      :color="compColor.primeColor"
                      :label="$t('COMPONENT_ADDRESS_DETAILS.LAND')"
                      v-model="patient.baseData.address.land"
                      :items="countryTypes"
                      outlined
                      :hide-details="!errors || errors.length <= 0"
                      :dense="denseFields"
                      :error-messages="errors[0]"
                      :dark="compColor.isInDarkMode">
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item v-on="on"
                                     :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                          <v-list-item-content class="py-0">
                            <label style="cursor:pointer;"
                                   :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                                   class="lighten-4 text--darken-2">{{ item.text }}</label>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                  </validation-provider>
                </div>
            </div>
          </div>
        </lx-expansion-panel-content>
      </lx-expansion-panel>
    </lx-expansion-panels>
  </div>
</template>

<script>
import metaData from '../../components/documentation/shared/formsMetaData'
import utils from '../../common/utils'

import InsuranceData from '../Patients/InsuranceData'

export default {
  name: "PatientBaseData",
  mixins: [metaData, utils],
  components: {
    InsuranceData
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        baseData: {
          insurance_data: {},
          address: {}
        }
      })
    },
    validationRef: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      patient: {
        baseData: {
          insurance_data: {},
          address: {},
          former_names: []
        }
      },
      panelBaseData: [0, 1, 2, 3],
      genderValues: null,
      nameSuffixValues: null,
      namePrefixValues: null,
      titleValues: null,
      countryTypes: null,
      resultSearchModel: {},
      DateAccuracyTypes: null,
      listJN: [
        { value: true, text: 'Ja' },
        { value: false, text: 'Nein' }
      ],
      showNotReportableConsent: false
    }
  },
  created () {
    this.countryTypes = this.formsMetaData.countryTypes
    this.titleValues = this.formsMetaData.titleValues
    this.nameSuffixValues = this.formsMetaData.nameSuffixValues
    this.namePrefixValues = this.formsMetaData.namePrefixValues
    this.genderValues = this.formsMetaData.genderValues
    this.DateAccuracyTypes = this.formsMetaData.DateAccuracyLong

    if (this.userCancerRegisterId) {
      // show ConsentNotReportable when cancer register is 'Niedersachsen'
      this.$http.get('/register/' + this.userCancerRegisterId)
          .then(res => {
            this.showNotReportableConsent = res.data?.name === 'Niedersachsen' || false
          })
          .catch(() => {this.showNotReportableConsent = false})
    } else {
      this.showNotReportableConsent = false
    }
  },
  methods: {
    /**
     * Modify insurance data object in dependency to selected kind of insurance data
     *
     * @param path The selected kind of insurance data
     */
    setKindOfInsuranceData (path) {
      ['gkv','pkv', 'sonstige'].forEach(state => {
        // delete all kind of insurance data, if not chosen via button
        // e.g. gkv !== pkv ===> delete gkv
        if (state !== path) {
          this.$delete(this.patient.baseData.insurance_data, state)
        }

        // set new kind of insurance data, if not exists after selection via button
        // if kind of insurance data already exists, there will be nothing changed
        if (state === path && !this.patient.baseData.insurance_data[path]) {
          this.$set(this.patient.baseData.insurance_data, path, {})
        }
      })
    },

    /**
     * Return label of insurance number in dependency to insurance state
     *
     * @returns {VueI18n.TranslateResult}
     */
    formatInsuranceNumberLabel () {
      let label = this.$t('COMPONENT_PATIENT.INSURANCE_NUMBER')

      if (!this.patient.baseData.insurance_status || this.patient.baseData.insurance_status !== 'private') {
        label += ' *'
      }

      return label
    },

    /**
     * Return localized string with different values of insurance data
     *
     * @param insuranceData The selected insurance data object e.g. gkv
     * @param path the name of the selected insurance data object
     * @returns {string}
     */
    formatInsuranceDataDiff (insuranceData, path) {
      const localizationMapping = {
        gkv: {
          iknr: 'COMPONENT_PATIENT.INSURANCE_COMPANY_NUMBER',
          gkv_versichertennummer: 'COMPONENT_PATIENT.INSURANCE_NUMBER'
        },
        pkv: {
          iknr: 'COMPONENT_PATIENT.INSURANCE_COMPANY_NUMBER_PKV',
          pkv_versichertennummer: 'COMPONENT_PATIENT.INSURANCE_NUMBER'
        },
        sonstige: {
          versichertennummer: 'COMPONENT_PATIENT.INSURANCE_NUMBER',
          beihilfetraeger: 'COMPONENT_PATIENT.INSURANCE_SUBSIDIARY',
          ersatzkode: 'COMPONENT_PATIENT.REPLACEMENT_CODE',
          krankenkassen_name: 'COMPONENT_PATIENT.INSURANCE_COMPANY_NAME'}
      }

      let returnValue = ''

      const listOfDataElements =  Object.keys(insuranceData || {})
      const count = listOfDataElements.length

      listOfDataElements.forEach((element, index) => {
        if (index === 0) {
          returnValue += '('
        }

        returnValue += this.$t(localizationMapping[path][element])

        if (index !== count -1) {
          returnValue += ', '
        }

        if (index === count - 1) {
          returnValue += ')'
        }
      })

      return returnValue
    },

    /**
     * Set base data of selected patient, if there is a difference to already existing patient
     *
     * @param patient
     * @param param
     * @param dataParam The selected object e.g. baseData
     */
    setBaseDataValues (patient, param, dataParam) {
      if (dataParam === 'baseData') {
        // only changes when base data should be replaced by already existing base data
        if (param === 'discard') {
          patient.baseData.lastname = patient.patientDiff.lastname ? patient.patientDiff.lastname : patient.baseData.lastname
          patient.baseData.firstname = patient.patientDiff.firstname ? patient.patientDiff.firstname : patient.baseData.firstname
          patient.baseData.gender = patient.patientDiff.gender ? patient.patientDiff.gender : patient.baseData.gender
          if (patient.patientDiff.name_prefix) {
            this.$set(patient.baseData, 'name_prefix', patient.patientDiff.name_prefix)
          }
          if (patient.patientDiff.name_suffix) {
            this.$set(patient.baseData, 'name_suffix', patient.patientDiff.name_suffix)
          }
          patient.baseData.title = patient.patientDiff.title ? patient.patientDiff.title : patient.baseData.title
        }

        // delete difference parameters to hide message
        this.$delete(patient.patientDiff, 'lastname')
        this.$delete(patient.patientDiff, 'firstname')
        this.$delete(patient.patientDiff, 'gender')
        this.$delete(patient.patientDiff, 'name_prefix')
        this.$delete(patient.patientDiff, 'name_suffix')
        this.$delete(patient.patientDiff, 'title')
      }

      if (dataParam === 'insurance_data') {
        // only changes when base data should be replaced by already existing base data
        if (param === 'discard') {
          patient.baseData.insurance_data = patient.patientDiff.insurance_data ? patient.patientDiff.insurance_data : patient.baseData.insurance_data
        }

        this.$delete(patient.patientDiff, 'insurance_data')

        this.$nextTick(() => {
          this.$refs.InsuranceData.validate()
        })
      }
    },

    /**
     * Set address of selected patient, if there is a difference to already existing patient
     *
     * @param patient
     * @param param
     */
    setAddressValue (patient, param) {
      // only make changes when address should be replaced by existing one
      if (param === 'discard' && patient.patientDiff.existingAddress) {
        patient.baseData.address = patient.patientDiff.existingAddress
      }

      // delete difference parameter to hide message
      this.$delete(patient.patientDiff, 'IsNewAddress')
      this.$delete(patient.patientDiff, 'existingAddress')
    }
  },
  computed: {
    insuranceIsInvalid () {
      let returnValue = false

      if (!this.patient.patientDiff || (!this.patient.patientDiff.insuranceNumber && !this.patient.patientDiff.insurance_company_number)) {
        const invalidInsuranceNumber = this.patient?.baseData && !this.patient.baseData.insurance_status && (!this.patient.baseData.insurance_number || this.patient.baseData.insurance_number.length < 6)

        if (this.patient && this.patient.baseData && (!this.patient.baseData.insurance_company_number || this.patient.baseData.insurance_company_number.length < 9 || invalidInsuranceNumber)) {
          returnValue = true
        }
      }

      return returnValue
    },
    baseDataHasDifferences () {
      return this.patient && this.patient.patientDiff && (this.patient.patientDiff.lastname || this.patient.patientDiff.firstname || this.patient.patientDiff.gender || this.patient.patientDiff.title || this.patient.patientDiff.name_prefix || this.patient.patientDiff.name_suffix)
    },
    insuranceDataHasDifferences () {
      return this.patient && this.patient.patientDiff && this.patient.patientDiff.insurance_data && (this.patient.patientDiff.insurance_data.insurance_status || this.patient.patientDiff.insuranceNumber)
    },
    userCancerRegisterId () {
      return this.getUserCancerRegisterDetails().register_id
    }
  },
  watch: {
    patient: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.patient = newValue
        }
      },
      immediate: true
    }
  }
}
</script>

